import React from 'react';
import { FaApple, FaGoogle } from "react-icons/fa";

const style = {
    backgroundColor: '#000000',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'nowrap',
    height: '100%'
};

const buttonTextStyle={
  flexGrow: 1,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontWeight: '500',
  letterSpacing: '0.25px'
}

const iconDivStyle={
  height: '18px',
  marginRight: '8px',
  minWidth: '18px',
  width: '18px'
}


const AppleSignInButton = props => {
  return (
    <div style={{height: '40px', minWidth: '100px', width:'auto'}}>
    <button style={style} className="btn" {...props}><div style={iconDivStyle}><FaApple/></div><span style={buttonTextStyle}>Sign in with Apple</span></button></div>
  );
};

export default AppleSignInButton;
